import * as Constants from './constants'

export const bacLuongListRequest = function bacLuongListRequest(formData) {
  return {
    type: Constants.BACLUONG_LIST_REQUESTING,
    payload: formData
  }
}

export const bacLuongListSuccess = function bacLuongListSuccess(data) {
  return {
    type: Constants.BACLUONG_LIST_SUCCESS,
    data
  }
}

export const bacLuongListError = function bacLuongListError(error) {
  return {
    type: Constants.BACLUONG_LIST_ERROR,
    error
  }
}

export const bacLuongDetailRequest = function bacLuongDetailRequest(formData) {
  return {
    type: Constants.BACLUONG_DETAIL_REQUESTING,
    payload: formData
  }
}

export const bacLuongDetailSuccess = function bacLuongDetailSuccess(data) {
  return {
    type: Constants.BACLUONG_DETAIL_SUCCESS,
    data
  }
}

export const bacLuongDetailError = function bacLuongDetailError(error) {
  return {
    type: Constants.BACLUONG_DETAIL_ERROR,
    error
  }
}

export const bacLuongUpdateRequest = (formData, callback) => {
  return {
    type: Constants.BACLUONG_UPDATE_REQUESTING,
    payload: formData,
    callback
  }
}

export const bacLuongUpdateSuccess = function bacLuongUpdateSuccess(response) {
  return {
    type: Constants.BACLUONG_UPDATE_SUCCESS,
    payload: response
  }
}

export const bacLuongUpdateError = function bacLuongUpdateError(error) {
  return {
    type: Constants.BACLUONG_UPDATE_ERROR,
    error
  }
}

export const bacLuongUserDetailRequest = function bacLuongUserDetailRequest(formData) {
  return {
    type: Constants.BACLUONG_USER_DETAIL_REQUESTING,
    payload: formData
  }
}

export const bacLuongUserDetailSuccess = function bacLuongUserDetailSuccess(data) {
  return {
    type: Constants.BACLUONG_USER_DETAIL_SUCCESS,
    data
  }
}

export const bacLuongUserDetailError = function bacLuongUserDetailError(error) {
  return {
    type: Constants.BACLUONG_USER_DETAIL_ERROR,
    error
  }
}


export const bacLuongUserUpdateRequest = (formData, callback) => {
  return {
    type: Constants.BACLUONG_USER_UPDATE_REQUESTING,
    payload: formData,
    callback
  }
}

export const bacLuongUserUpdateSuccess = function bacLuongUpdateSuccess(response) {
  return {
    type: Constants.BACLUONG_USER_UPDATE_SUCCESS,
    payload: response
  }
}

export const bacLuongUserUpdateError = function bacLuongUpdateError(error) {
  return {
    type: Constants.BACLUONG_USER_UPDATE_ERROR,
    error
  }
}

export const bacLuongUserListRequest = function bacLuongUserListRequest(formData) {
  return {
    type: Constants.BACLUONG_USER_LIST_REQUESTING,
    payload: formData
  }
}

export const bacLuongUserListSuccess = function bacLuongUserListSuccess(data) {
  return {
    type: Constants.BACLUONG_USER_LIST_SUCCESS,
    data
  }
}

export const bacLuongUserListError = function bacLuongUserListError(error) {
  return {
    type: Constants.BACLUONG_USER_LIST_ERROR,
    error
  }
}


// WEBPACK FOOTER //
// ./src/views/BacLuong/actions.js